import styled, { css } from 'styled-components';
import { appTheme } from 'styles/theme';

interface IHeading extends React.HtmlHTMLAttributes<HTMLElement> {
  color?: 'white' | 'black' | 'light';
}

const variantOptions = {
  color: {
    white: appTheme.colors.white,
    black: appTheme.colors.black,
    light: appTheme.colors.text_light,
  },
};

const H3 = styled.h3<IHeading>`
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.2px;
  font-family: ${({ theme }) => theme.typography.fonts.monoMedium};
  text-transform: uppercase;

  @media (min-width: ${({ theme }) => theme.breakpoints.l}) {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.2px;
  }

  ${({ color }) =>
    color &&
    variantOptions.color[color] &&
    css`
      color: ${variantOptions.color[color]};
    `}
`;

export default H3;
